<template>
<div id="satisfaction-client" class="data-list-container">
    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="dataList" @selected="rowClick">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                <!-- ACTION - DROPDOWN -->
            </div>
        </div>
        <template slot="thead">
            <vs-th sort-key="Item_No" class="table_head_color"> Code </vs-th>
            <vs-th sort-key="Year" class="table_head_color">Nom Complet</vs-th>
            <vs-th sort-key="Year" class="table_head_color">Email</vs-th>
            <vs-th sort-key="Year" class="table_head_color">Magasin</vs-th>
            <vs-th sort-key="Year" class="table_head_color">N° Tel</vs-th>
        </template>

        <template slot-scope="{data}">
            <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <p>{{ tr[0] }}</p>
                    </vs-td>

                    <vs-td>
                        <p v-if="tr[2] == null">{{ tr[1] }}</p>
                        <p v-else>{{ tr[1] + ' ' + tr[2]}}</p>
                    </vs-td>

                    <vs-td>
                        <p>{{ tr[4] }}</p>
                    </vs-td>

                    <vs-td>
                        <p>{{ tr[3] }}</p>
                    </vs-td>

                    <vs-td>
                        <p>{{ tr[5] }}</p>
                    </vs-td>

                    <!-- <vs-td>
                        <img v-if="tr.evaluation=='Sad'" :src="sadFace" alt="user-img" width="18" height="18" class="ml-3" />
                        <img v-else-if="tr.evaluation=='Confused'" :src="confusedFace" alt="user-img" width="18" height="18" class="ml-3" />
                        <img v-else :src="happyFace" alt="user-img" width="18" height="18" class="ml-3" />
                    </vs-td> -->
                </vs-tr>
            </tbody>
        </template>
    </vs-table>
</div>
</template>

<script>
import pdf from "vue-pdf";
import indexEvaluation from "@/http/requests/evaluation/index.js";

//import service from "./dashboardService.js";
export default {
    components: {
        pdf
    },
    data() {
        return {
            sadFace: require("@/assets/images/portrait/small/sad.png"),
            confusedFace: require("@/assets/images/portrait/small/confused.png"),
            happyFace: require("@/assets/images/portrait/small/happy.png"),
            itemsPerPage: 10,
            currentPage: 1,
            dataList: [],
            cellAutoWidth: true,
        };
    },
    watch: {
        dataList: function (val) {
            if (val.length >= 0) {
                this.$vs.loading.close("#satisfaction-client > .con-vs-loading");
            }
        }
    },
    computed: {},
    methods: {
        rowClick(tr) {
            this.$router.push('/admin/client/satisfaction/detaillee/'+tr[6])
        },
        loadData() {
            try {
                indexEvaluation.getListClients().then(response => {
                    console.log(response)
                    this.dataList = response.data
                })
                this.$vs.loading.close("#satisfaction-client > .con-vs-loading");
            } catch {
                this.$vs.loading.close();
                this.$vs.notify({
                    time: 10000,
                    title: "Erreur s'est produite l'ors de la récupération de données",
                    text: "Erreur",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circles"
                });
            }
        }
    },

    created() {
        if (this.$store.state.AppActiveUser.id != '') {
            this.loadData();
        } else {
            this.$store.subscribe(mutation => {
                if (mutation.type === "UPDATE_USER_INFO") {
                    this.loadData();
                }
            });
        }
    },
    mounted() {}
};
</script>

<style lang="scss">
#satisfaction-client {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000000;

    .vs-table {
        border-collapse: separate;
        // border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
            box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.05);

            td {
                align-items: center;
                justify-content: center;
                text-align: center;
                vertical-align: middle;

                &:first-child {
                    border-top-left-radius: 0.5rem;
                    border-bottom-left-radius: 0.5rem;
                }

                &:last-child {
                    border-top-right-radius: 0.5rem;
                    border-bottom-right-radius: 0.5rem;
                }

                &.img-container {
                    span {
                        display: flex;
                        justify-content: flex-start;
                    }

                    .product-img {
                        height: 110px;
                    }
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 5;
                padding-bottom: 5;
                color: "primary";
                background: #002b5c;
                justify-content: center;

                .vs-table-text {
                    //text-transform: uppercase;
                    font-weight: 600;
                    color: white;
                    justify-content: center;
                }
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .product-name {
        max-width: 23rem;
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        >span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search {
            padding-top: 0;

            .vs-table--search-input {
                padding: 0.9rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }
}
</style>
